<template>
  <div class="container bg-white">
    <div class="row">
      <div class="col-xs-18">
        <h3>{{ $t('privacy.merekDagangBeliruma.title') }}</h3>
        <div class="divider"></div>
        <p>{{ $t('privacy.merekDagangBeliruma.line1') }}</p>
        <p>{{ $t('privacy.merekDagangBeliruma.line2') }}</p>
        <p>{{ $t('privacy.merekDagangBeliruma.line3') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'merk-dagang-beliruma',
};
</script>
